export default __webpack_public_path__ + "static/media/porchpi.46fbe03e.jpg";